import { render, staticRenderFns } from "./AnswerForm.vue?vue&type=template&id=4f80845b&scoped=true&"
import script from "./AnswerForm.vue?vue&type=script&lang=js&"
export * from "./AnswerForm.vue?vue&type=script&lang=js&"
import style0 from "./AnswerForm.vue?vue&type=style&index=0&id=4f80845b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f80845b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDivider,VIcon,VImg})
